// startup
// Load entry module
__webpack_require__("./components/02-molecules/menus/tabs/tabs.js");
// This entry module used 'exports' so it can't be inlined
